<template>
  <b-form-group>
    <b-form-input :value="selection"
                  @input='change'
                  list="my-list-id"
                  autocomplete="off"
                  placeholder="Start typing his/her UserName"
                  type="text"/>
    <datalist id="my-list-id">
      <option v-for="suggestion in suggestions">{{ suggestion }}</option>
    </datalist>
  </b-form-group>
</template>

<script>
import axios from 'axios'
import {eventBus} from '../main'

export default {
  data () {
    return {
      Choice: '',
      suggestions: []
    }
  },

  props: {
    'selection': Array,
    EventBus: String
  },

  methods: {
    change () {
      this.Choice = event.target.value
      axios.get('/user/loginByPrefix?start=0&count=10&prefix=' + this.Choice,
        {withCredentials: true})
        .then(
          response => {
            console.log(response)
            this.suggestions = response.data
          })
      eventBus.$emit(this.EventBus, this.Choice)
    }

  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Autocomplete.vue